import React from 'react';
import styled from 'styled-components';
import logomark from '@99designs/frontend-components/core/images/99designs-byVP-logomark.svg';

const StyledLogomark = styled.div`
    display: inline-block;
    text-align: center;
    width: 59px;
    height: 41px;
`;

export function Logomark() {
    return (
        <StyledLogomark
            dangerouslySetInnerHTML={{
                __html: logomark,
            }}
            aria-label={__('99designs by Vistaprint')}
        />
    );
}
